import React, { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomHelmet from "../../component/reusable/Helmet";
import { FaArrowLeftLong } from "react-icons/fa6";
import gd1 from "../../images/howuse/gd1.png";
import gd2 from "../../images/howuse/gd2.png";

import gd3 from "../../images/howuse/gd3.png";

import gd4 from "../../images/howuse/gd4.png";

import ssb_mentor_1 from "../../images/howuse/ssb_mentor_1.png";
import ssb_mentor_2 from "../../images/howuse/ssb_mentor_2.png";

const GroupDiscussionHowUse = () => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <CustomHelmet
        title="SSB-GPT: Your SSB Interview Self Preparation Tool"
        description="Prepare effectively for your SSB/AFSB/NSB/ interview with SSB-GPT, a free self-preparation tool."
      />
      {/* <GptHeader /> */}

      <section className="how_UseClassRoom_main">
        <div className="container">
          <div className="bacbtnWthHeading">
            <button
              title="back"
              className="backBtn"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeftLong />
            </button>
            <h1 className="main_heading">
              How to Use Group Discussion Classroom
            </h1>
          </div>
        </div>
        <div className="howUse_content container">
          <p>Welcome, Alpha Warriors!</p>
          <br />
          <p>
            Group Discussion (GD) is a vital component of the SSB process,
            evaluating your ability to work in a team, articulate your ideas,
            and showcase Officer-Like Qualities (OLQs). This is your chance to
            demonstrate leadership, critical thinking, and effective
            communication while engaging in a meaningful discussion on a given
            topic.
          </p>
          <br />
          <p>
            To help you excel, AI SSB Mentor Captain Alpha will conduct mock GD
            sessions that replicate real SSB scenarios. These sessions are
            tailored to enhance your ability to present your ideas confidently,
            contribute constructively, and collaborate effectively with your
            group.
          </p>
          <br />
          <p>
            Get ready to sharpen your group discussion skills and prepare to
            lead with confidence under the expert guidance of Captain Alpha! 🚀
          </p>
          <br />
          <p>Here’s how you can join and start practicing :</p>
          <h2 className="subHeading">
            Step-by-Step Guide to Join the Group Discussion Classroom
          </h2>
          <h3 className="tab_heading">
            <b>Step 1.</b> Navigate to the Home Page {`>>`}{" "}
            <Link to="/chat">Ask Your SSB Mentor Now</Link>{" "}
          </h3>
          <img
            src={ssb_mentor_1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 2.</b> Click <b>“Choose Classroom”</b>
          </h3>
          <img
            src={ssb_mentor_2}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 3.</b> Choose <b>“Group Discussion”</b>
          </h3>
          <img
            src={gd1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 4.</b> Click the <b>“Start”</b> button
          </h3>
          <img
            src={gd2}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 5.</b> Read the instructions carefully and Click the “Start”
            button
          </h3>
          <p>
            Read the instructions carefully so that your Group Discussion
            session can run smoothly without any interruption. Click on the
            “Start” button.
          </p>
          <img
            src={gd3}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <br />
          <h3 className="tab_heading">
            <b>Step- 6.</b> Familiarize yourself with your classroom interface
          </h3>
          <img
            src={gd4}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <br />
          <br />
          <ul>
            <li>
              Whatever you speak will be automatically transcribed here. If you
              notice any errors due to background noise, misinterpretation, or
              other reasons, you can correct them before submitting.
            </li>
            <li>
              Once you’ve ensured your answer is correctly typed, click Submit.
            </li>
            <li>
              If the automatic transcription stops for any reason, click the mic
              icon to refresh it.
            </li>
          </ul>
          <br />
          <h4 className="subHeading">Last Step. Enjoy your Group Discussion</h4>
          <p>
            This way, your group discussion practice can continue seamlessly for
            as long as you need.
          </p>
          <br />
          <p>
            By following these steps, you can ensure a smooth and productive
            group discussion practice. For further assistance, feel free to
            reach out to support!
          </p>
          <br />
          <p>
            Jai Hind! <br />
            Over and out!
          </p>
        </div>
      </section>
      {/* <Footer /> */}
    </Fragment>
  );
};

export default GroupDiscussionHowUse;
